import { BlockProps, LinkProps } from "@/utils/types";
import { BlockWrapper } from "./BlockWrapper";
import { Event, EventProps } from "../modules/Event";
import { sanitize } from "@/utils/sanitize";

export interface EventsProps extends BlockProps {
  items: EventProps[];
  link?: LinkProps;
}

export const Events = ({
  backgroundColor = "bg-white",
  bottom,
  className,
  colorStarter,
  componentId,
  heading,
  items,
  link = {
    copy: "View All Events",
    href: "/events",
  },
  primaryEnder,
}: EventsProps) => {
  const lightMode =
    sanitize(backgroundColor) === "bg-white" ||
    sanitize(backgroundColor) === "pattern" ||
    sanitize(backgroundColor) === "bg-secondary" ||
    sanitize(backgroundColor) === "bg-tertiary";

  const hasWave = sanitize(backgroundColor) === "waves";
  const hasPattern = sanitize(backgroundColor) === "pattern";

  const blockProps = {
    backgroundColor,
    bottom,
    colorStarter,
    componentId,
    heading,
    lightMode,
    primaryEnder,
  };

  return (
    <BlockWrapper
      {...blockProps}
      className={`events${className ? ` ${className}` : ""}`}
    >
      <div
        className={`flex flex-col justify-center items-center gap-10 w-full ${hasWave ? "max-w-[700px] bg-primary shadow-md rounded-lg py-8 px-4  mx-auto" : hasPattern ? "max-w-[700px] bg-secondary shadow-md rounded-lg py-8 px-4  mx-auto" : "contained"}`}
      >
        <div className="w-full">
          {items && items.length > 0 ? (
            items.map((item, i) => (
              <Event
                key={item.title + i}
                {...item}
                lightMode={lightMode}
                isBottom={i === items.length - 1}
              />
            ))
          ) : (
            <>
              <h2 className="uppercase font-display text-center text-6xl text-pretty text-tertiary leading-[1.2]">
                No Events Scheduled at this time
              </h2>
            </>
          )}
        </div>
        {link && (
          <a className="button secondary w-auto" href={link.href}>
            {link.copy}
          </a>
        )}
      </div>
    </BlockWrapper>
  );
};
